import styled from "styled-components"
export const ShareModalStyle = styled.div`

    .qr-code {
        text-align: center;
        img {
            width: 150px;
        }
        .weixin-tip {
            margin: 5px 0 20px;
        }
    }

    .down{
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        gap:  ${props=> props.theme.space.paddingLG}px;
       
        .item{
            font-size: 32px;
            display: flex;
            flex-direction: column;
            align-items: center;
            cursor: pointer;
            .icon{
                width: 100%;
                aspect-ratio: 1;
                display: flex;
                justify-content: center;
                align-items: center;
                color:#fff;
                background-color:${props=> props.theme.colors.colorPrimary};
                border-radius: 50%;
            }
            span{
                font-size: ${props=> props.theme.fontSizes.fontSize}px;
                padding:${props=> props.theme.space.padding}px 0;
            }
        }
       }
`